import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import Context from '../../context/mainContext'
import {
  Grid
} from '@material-ui/core'
import Notification from '../notification'
import { saveError } from '../../firebase/obj/error'
//import Avatar from '@material-ui/core/Avatar'
import { navigate } from '@reach/router'

const useStyles = makeStyles({
  avatar: {
    margin: 10,
    width: 80,
    height: 80,
  },
  google: {
    display: 'inline-block',
    background: 'white',
    color: '#444',
    borderRadius: '5px',
    border: 'thin solid #888',
    boxShadow: '1px 1px 1px grey',
    whiteSspace: 'nowrap',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  userContainer: {
    width: 100
  },
  buttonUser: {
    width: 120,
    height: 'auto',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    fontSize: '12px',
    padding: '5px',
    textTransform: 'capitalize'
  },
  button: {
    width: 120,
    fontSize: '11px',
    padding: '5px 15px',
    zIndex: 100
  },
  buttonText: {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingLeft: 'auto',
    paddingRight: 'auto',
    fontSize: '14px',
    fontWeight: 'bold',
    /* Use the Roboto font that is loaded in the <head> */
    fontFamily: "'Roboto', sans-serif",
  }
})

let loginCount = 0

const UserComponent = ({ logOut, loginWithGoogle }) => {
  const classes = useStyles()
  const [notificationOpen, setNotificationOpen] = useState(false)

  const handleLoginWithGoogle = () => {
    loginWithGoogle()
      .then(() => loginCount = 0)
      .catch(error => {
        saveError(error)
        if (error.code === 'auth/network-request-failed') {
          if (loginCount < 6) {
            loginCount++
            return handleLoginWithGoogle()
          }
        } else {
          setNotificationOpen(true)
          loginCount = 0
        }
      })
  }

  return <Grid>
    <Notification notificationOpen={notificationOpen} handleNotificationClose={() => setNotificationOpen(false)} severity='error' notificationMessage='No se pudo iniciar sesión con google' />
    <Context.Consumer>
      {
        ({ user }) => user ?
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="stretch"
            className={classes.userContainer}
          >
            {/* <Avatar alt={user.displayName} src={user.photoURL} className={classes.avatar} /> */}
            <Button variant="outlined" className={classes.buttonUser} style={{ marginBottom: 10 }} color="default" size="small" onClick={() => navigate("/cuenta")}>{user.displayName}</Button>
            <Button variant="outlined" className={classes.button} color="secondary" size="small" onClick={logOut}>Cerrar sesión</Button>
          </Grid>
          :
          <Button variant="contained" className={classes.google} size="small" onClick={handleLoginWithGoogle}>
            <span className={classes.buttonText}>
              Ingresar
            </span>
          </Button>
      }
    </Context.Consumer>

  </Grid>
}




export default UserComponent